import { computed, nextTick, ref, watch } from 'vue'
import { useElementSize } from '@vueuse/core'

import type {
  SelectTriggerTooltipOptions,
  SelectTriggerTooltipReturn,
} from '../types/core'

export const useSelectTriggerTooltip = (
  options: SelectTriggerTooltipOptions,
): SelectTriggerTooltipReturn => {
  const { inputRef, text, isOpen } = options

  const isTruncated = ref(false)

  const { width } = useElementSize(inputRef)

  const measure = (): void => {
    const el = inputRef.value
    isTruncated.value = el !== null && el.scrollWidth > el.clientWidth
  }

  const tooltipText = computed<string>(() => (
    !isOpen.value && isTruncated.value ? text.value : ''
  ))

  watch([text, width], () => void nextTick(measure), { immediate: true })

  return {
    tooltipText,
  }
}
